/* @flow */
import Button from 'components/Button.jsx';
import Groups from 'collections/Groups';
import CopySubscriberDialog from './CopySubscriberDialog.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import Relationship from 'entities/Relationship';
import cx from 'classnames';
import './styles/CopySubscriberButton.scss';

class CopySubscriberButton extends React.Component {
  static propTypes = {
    relationship: React.PropTypes.instanceOf(Relationship).isRequired,
    groups: React.PropTypes.instanceOf(Groups).isRequired,
    size: React.PropTypes.oneOf(['normal', 'small']),
  };

  static defaultProps = {
    size: 'normal',
  };

  getUnjoinedOwnedGroups = () => {
    const { relationship } = this.props;
    const subscriptions = relationship.getSubscriptionsToMe();
    return new Groups(this.props.groups.filter(group => {
      return !subscriptions.some(subscription => {
        return subscription.getGroupId() === group.id;
      });
    }));
  };

  renderCopySubscriberDialog = () => {
    return (
      <CopySubscriberDialog
        relationship={this.props.relationship}
        groups={this.props.groups}
      />
    );
  };

  render() {
    const unjoinedGroups = this.getUnjoinedOwnedGroups();
    const hasUnjoinedGroup = unjoinedGroups.length > 0;

    let tooltip;
    if (!hasUnjoinedGroup) {
      const { relationship } = this.props;
      const subscriber = relationship.getRelatedUser();
      const name = subscriber.getName();
      tooltip = `${name} has joined all of your classes.`;
    }

    let button = (
      <Button
        {...this.props}
        className={cx('CopySubscriberButton', {
          'CopySubscriberButton-small': this.props.size === 'small',
          'CopySubscriberButton-disabled': !hasUnjoinedGroup,
        }, this.props.className)}
        color="brand"
        level="text"
        size="small"
        tooltip={tooltip}
        tooltipPlacement="bottom">
        Copy to another class
      </Button>
    );

    if (hasUnjoinedGroup) {
      button = (
        <ModalTrigger modal={this.renderCopySubscriberDialog()}>
          {button}
        </ModalTrigger>
      );
    }

    return button;
  }
}

export default CopySubscriberButton;



// WEBPACK FOOTER //
// ./src/groups/components/CopySubscriberButton.jsx